import { useContext, useEffect, useRef } from 'react';
import { useHistory } from 'react-router';

import { DocumentCaptureOfferContext } from '../../../../DocumentCaptureContexts';
import { IncodeContainer } from '../IncodeContainer';
import type { IncodeStepProps } from '../IncodeSDKHelpers';
import { INCODE_PROGRESS_STATUS, INCODE_PROGRESS_STEP, INCODE_ROUTES } from '../IncodeSDKHelpers';
import { usePostIncodeProgress } from '../progress/incodeProgress';

import { IncodeCaptureDevHelper } from './IncodeCaptureDevHelper';

import styles from './IncodeCaptureFSL.module.scss';

export const IncodeCaptureFSL = ({
  BASE_URL,
  incodeSDK,
  incodeSession,
}: IncodeStepProps) => {
  const incodeContainerRef = useRef<HTMLDivElement>(null);

  const history = useHistory();
  const { IncodeProgressLoading, postIncodeComplete } = usePostIncodeProgress();
  const { data } = useContext(DocumentCaptureOfferContext);
  const name = data?.seller?.keeperName || data?.seller?.Name;

  useEffect(() => {
    const incodeContainerRefCurrent = incodeContainerRef.current;
    const abortController = new AbortController();

    const defaultCompleteParams = {
      abortController,
      fallbackNextStep: INCODE_ROUTES.COMPLETE,
      incodeSession,
      step: INCODE_PROGRESS_STEP.FINANCE,
    };

    const { close } = incodeSDK.renderCamera('document', incodeContainerRefCurrent, {
      documentType: 'processFinanceSettlement',
      nativeCamera: true,
      onError: () => postIncodeComplete({
        ...defaultCompleteParams,
        status: INCODE_PROGRESS_STATUS.FAILED,
      }),
      onSuccess: () => postIncodeComplete({
        ...defaultCompleteParams,
        status: INCODE_PROGRESS_STATUS.SUCCESS,
      }),
      token: incodeSession,
    });

    return () => {
      abortController.abort();
      close();
    };
  }, [BASE_URL, history, incodeContainerRef, incodeSDK, incodeSession, postIncodeComplete]);

  return (
    <>
      <IncodeProgressLoading />
      <IncodeContainer ref={incodeContainerRef} noStyling attrs={{
        'data-keeper-name': name ? `: (${name})` : '',
      }} className={styles.fsl} />
      <IncodeCaptureDevHelper to={INCODE_ROUTES.PROOF_OF_ADDRESS} />
    </>
  );
};
